import React from 'react';
import { IQuestionnaireItemIntegerComponent } from '../../modules/unsw-fhir/Questionnaire';
import { Conditionals } from '../Fields/Conditional';
import { generateSimpleEnableWhenPredicate } from '../../modules/unsw-fhir/QuestionnaireResponse/helpers';
import IntegerField from '../Fields/NumberField';
import { QuestionnaireItemValidator } from '../../modules/unsw-fhir-questionnaire/Utilities/Validators';
import {
  getPromptTexts,
  getSupportingLinkUris,
  getMinValue,
  getMaxValue,
} from '../../modules/unsw-fhir/Questionnaire/extensions';
import { useModal } from '../../modules/unsw-modals';

const QuestionnaireIntegerItem = (
  props: IQuestionnaireItemIntegerComponent,
) => {
  const { enableWhen, ...rest } = props;
  const prompts = getPromptTexts(props);
  const supportLinks = getSupportingLinkUris(props);
  const min = getMinValue(props);
  const max = getMaxValue(props);
  const { openSupportingLinks } = useModal();

  return enableWhen ? (
    <Conditionals
      question={props.linkId}
      enableWhens={enableWhen.map(ew => ({
        when: ew.question,
        is: generateSimpleEnableWhenPredicate(ew),
      }))}>
      {({ enabled }) => (
        <IntegerField
          informationText={prompts}
          name={props.linkId}
          supportingLink={
            supportLinks.length !== 0
              ? () => openSupportingLinks(supportLinks)
              : undefined
          }
          validate={QuestionnaireItemValidator(props)}
          enabled={enabled}
          min={min}
          max={max}
          {...rest}
        />
      )}
    </Conditionals>
  ) : (
    <IntegerField
      informationText={prompts}
      name={props.linkId}
      supportingLink={
        supportLinks.length !== 0
          ? () => openSupportingLinks(supportLinks)
          : undefined
      }
      validate={QuestionnaireItemValidator(props)}
      min={min}
      max={max}
      {...rest}
    />
  );
};

export default QuestionnaireIntegerItem;
